import React, { useState, useEffect } from 'react';
import './profilePage.css';
import {
  FaGraduationCap,
  FaScroll,
  FaCertificate,
  FaBriefcase,
  FaUsers,
  FaAward,
  FaChevronDown,
  FaChevronUp,
  FaRegEdit
} from 'react-icons/fa';
import profilePic from './dr_ember_wynn_placeholder.png';
import { get, put, post, del } from '../../../utility/fetch';
import EditModal from '../../modals/EditModal';
import AddModal from '../../modals/AddModal';
import ImageViewerModal from '../../modals/ImageViewerModal';
import { toast } from 'react-hot-toast';
import AddIcon from '@mui/icons-material/Add';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Avatar,
  Stack,
  CircularProgress,
  Stepper,
  Step,
  StepLabel,
  Autocomplete,
  Skeleton
} from '@mui/material'; import ConfirmationModal from '../../modals/ConfirmationModal';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import notification from '../../../utility/notification';
import UploadButton from '../../Layout/UploadButton';

function ProfilePage() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openAccordion, setOpenAccordion] = useState('education');
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addingModalOpen, setAddingModalOpen] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const [addingSection, setAddingSection] = useState(null);
  const [editingItem, setEditingItem] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [addValues, setAddValues] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deletingSection, setDeletingSection] = useState(null);
  const [deletingItem, setDeletingItem] = useState(null);
  const [nationality, setNationality] = useState([]);
  const [docUploading, setDocUploading] = useState(false);
  const [personalInfo, setPersonalInfo] = useState(null);
  const [spokenLanguagesOptions, setSpokenLanguagesOptions] = useState([])
  const [states, setStates] = useState([])
  const [providers, setProviders] = useState([]);
  const [roleSpecialists, setRoleSpecialists] = useState([]);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);
  const [viewingImage, setViewingImage] = useState({ url: '', title: '' });
  
  const location = useLocation();

  // Fetch profile data from API
  const getProfileDetails = async () => {
    setLoading(true);
    try {
      const res = await get(
        `/employeeaccount/list/employee/${sessionStorage.getItem('userId')}`
      );
      if (res.statusCode === 200) {
        setProfile(res?.data || {});
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPersonalInfo = async () => {
    try {
      const res = await get(`/employee/employee/${sessionStorage.getItem('userId')}`);
      if (res?.statusCode === 200) {
        setPersonalInfo(res.data);
      }
    } catch (error) {
      console.error('Error fetching personal info:', error);
    }
  };

  const fetchLanguages = async () => {
    try {
      const res = await get('/employee/spoken-language/list');
      if (res?.isSuccess) {
        const options = res.data.map((lang) => ({
          label: lang.name,
          value: lang.id
        }));
        setSpokenLanguagesOptions(options);
      }
    } catch (error) {
      console.error('Failed to fetch spoken languages', error);
    }
  };

  const fetchState = async () => {
    try {
      const res = await get('/employee/state-list');
      if (res?.isSuccess) {
        const options = res.data.map((lang) => ({
          label: lang.name,
          value: lang.id
        }));
        setStates(options);
      }
    } catch (error) {
      console.error('Failed to fetch spoken languages', error);
    }
  };

  const fetchSpecialties = async () => {
    try {
      const res = await get('/rolespecialist/list');
      if (res?.isSuccess) {
        const options = res.data.map((specialty) => ({
          label: specialty.specialistName,
          value: specialty.id,
          role: specialty.role.name
        }));
        setRoleSpecialists(options);
      }
    } catch (error) {
      console.error('Failed to fetch specialties', error);
    }
  };

  const getNationality = async () => {
    try {
      const response = await axios.get(`https://api.greenzonetechnologies.com.ng/connectedhealthlabapi/api/hmo/nationality/list`);
      setNationality([
        { name: "Select Nationality", value: 0 },
        ...response?.data.data?.map((state) => ({
          label: state?.name,
          value: parseInt(state?.id),
        }))
      ]);
    } catch (error) {
      console.error("Error fetching nationalities:", error);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          getProfileDetails(),
          getNationality(),
          getPersonalInfo(),
          fetchLanguages(),
          fetchState(),
          fetchSpecialties() // Fetch specialties
        ]);
      } catch (error) {
        console.error('Error initializing data:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  // Handle navigation from sidebar
  useEffect(() => {
    if (location.state?.openSection) {
      setOpenAccordion(location.state.openSection);
    }
  }, [location.state]);

  // Accordion sections
  const sections = [
    // {
    //   id: 'personal-info',
    //   label: 'Personal Info',
    //   icon: FaRegEdit,
    //   hasContent: personalInfo?.id
    // },
    {
      id: 'education',
      label: 'Education',
      icon: FaGraduationCap,
      hasContent: profile?.educations?.length > 0
    },
    {
      id: 'licenses',
      label: 'Licenses',
      icon: FaScroll,
      hasContent: profile?.licenses?.length > 0
    },
    {
      id: 'certifications',
      label: 'Certifications',
      icon: FaCertificate,
      hasContent: profile?.certificates?.length > 0
    },
    {
      id: 'work-experiences',
      label: 'Work Experiences',
      icon: FaBriefcase,
      hasContent: profile?.workExperiences?.length > 0
    },
    {
      id: 'associations',
      label: 'Associations',
      icon: FaUsers,
      hasContent: profile?.associations?.length > 0
    },
    {
      id: 'awards-recognition',
      label: 'Awards & Recognition',
      icon: FaAward,
      hasContent: profile?.awardAndRecognitions?.length > 0
    },
  ];

  const toggleAccordion = (id) => {
    if (id === 'personal-info' && !personalInfo?.id) return;

    setOpenAccordion(openAccordion === id ? null : id);
  };


  // Opens the docPath of a document object
  const handleViewDocument = (documentObj, title = "Certificate/Document") => {
    if (documentObj?.docPath) {
      // Extract filename from URL
      const extractFileNameFromUrl = (url) => {
        if (!url) return 'Document';
        try {
          const urlPath = url.split('/').pop();
          if (urlPath && urlPath.includes('_')) {
            const parts = urlPath.split('_');
            if (parts.length > 1) {
              return parts.slice(1).join('_');
            }
          }
          return urlPath || 'Document';
        } catch (error) {
          return 'Document';
        }
      };

      const filename = extractFileNameFromUrl(documentObj.docPath);
      const displayTitle = title !== "Certificate/Document" ? `${title} (${filename})` : filename;
      
      setViewingImage({
        url: documentObj.docPath,
        title: displayTitle
      });
      setImageViewerOpen(true);
    } else {
      notification({
        type: 'error',
        message: 'No document available'
      });
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Helper function to update completion status in session storage
  const updateCompletionStatus = (section, hasData) => {
    const sessionKeys = {
      education: 'isEducationCompleted',
      licenses: 'isLicenceCompleted',
      certifications: 'isCertificateCompleted',
      'work-experiences': 'isWorkExperienceCompleted',
      associations: 'isAssociationCompleted',
      'awards-recognition': 'isAwardsCompleted'
    };

    const sessionKey = sessionKeys[section];
    if (sessionKey) {
      sessionStorage.setItem(sessionKey, hasData.toString());
    }
  };

  const handleEditClick = (e, section, item) => {
    e.stopPropagation();
    setEditingSection(section);
    setEditingItem(item);

    // Convert string dates to Date objects and map document fields
    const parsedItem = {
      ...item,
      startDate: item.startDate ? new Date(item.startDate) : null,
      endDate: item.endDate ? new Date(item.endDate) : null,
      validityDate: item.validityDate ? new Date(item.validityDate) : null,
    };

    // Map document fields based on section
    if (section === 'education' && item.employeeEducationCertificateDocument) {
      parsedItem.document = item.employeeEducationCertificateDocument;
    } else if (section === 'licenses' && item.employeeLicenseCertificateDocument) {
      parsedItem.document = item.employeeLicenseCertificateDocument;
    } else if (section === 'certifications' && item.employeeCertificateDocument) {
      parsedItem.document = item.employeeCertificateDocument;
    }

    setEditValues(parsedItem);
    setEditModalOpen(true);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setEditingSection(null);
    setEditingItem(null);
    setEditValues({});
  };

  const handleEditChange = (name, value) => {
    setEditValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePersonalInfoSubmit = async (values) => {
    try {
      const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const payload = {
        ...values,
        dateOfBirth: values.dateOfBirth ? formatDate(values.dateOfBirth) : null,
        spokenLanguages: values.spokenLanguages.map((lang) => ({ spokenLanguageId: lang.id })), // Correct structure
        specialtyId: values.specialtyId || values.roleIds?.[0]?.value || 0, // Ensure correct specialtyId is sent
        companyLogoUrl: values.companyLogoUrl || '',
        associatedClinics: values.associatedClinics || [],
        workSchedule: values.workSchedule || [],
        profileType: values.profileType || 'Private Practitioner',
        description: values.description || ''
      };

      const res = await put(`/employee/${sessionStorage.getItem('userId')}`, payload);
      if (res?.statusCode === 200) {
        toast.success('Personal info updated');
        setPersonalInfo(payload); // Refresh local copy
      } else {
        toast.error('Failed to update');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error occurred while updating');
    }
  };
  const personalInfoFields = [
    { name: 'govtIssuedIDType', label: 'ID Type' },
    { name: 'govtIssuedID', label: 'ID Number' },
    { name: 'title', label: 'Title' },
    { name: 'firstName', label: 'First Name' },
    { name: 'middleName', label: 'Middle Name' },
    { name: 'lastName', label: 'Last Name' },
    { name: 'phoneNumber', label: 'Phone Number' },
    { name: 'email', label: 'Email' },
    { name: 'gender', label: 'Gender' },
    { name: 'dateOfBirth', label: 'Date of Birth', type: 'date' },
    { name: 'placeOfBirth', label: 'Place of Birth' },
    { name: 'stateId', label: 'State', type: 'select', options: states },
    { name: 'lga', label: 'LGA' },
    { name: 'city', label: 'City' },
    { name: 'nationalityId', label: 'Nationality', type: 'select', options: nationality },
    { name: 'officeAddress', label: 'Office Address' },
    {
      name: 'spokenLanguages',
      label: 'Spoken Languages',
      type: 'select',
      multiple: true,
      options: spokenLanguagesOptions
    },
    {
      name: 'companyLogoUrl', label: 'Company Logo', type: 'uploadButton', component: UploadButton, props: {
        acceptedFiles: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
        buttonText: 'Upload company logo',
        onUploadSuccess: (response) => {
          if (response?.code === 1) {
            const documentData = response.doclink

            handleEditChange('companyLogoUrl', documentData);
          }
        }
      },
    },
    // { name: 'associatedClinics', label: 'Associated Clinics', type: 'text' },
    // { name: 'workSchedule', label: 'Work Schedule', type: 'text' },
    { name: 'profileType', label: 'Profile Type', type: 'select', options: [{ value: 1, label: 'Private Practitioner' }] },
    { name: 'description', label: 'Description', multiline: true },
    { name: 'specialtyId', label: 'Specialty', type: 'select', options: roleSpecialists }
  ];


  // Define fields for each section’s EditModal
  const getFieldsForSection = (section, isAdd = false) => {
    const baseFields = {
      education: [
        { name: 'institutionName', label: 'Institution Name' },
        { name: 'fieldOdStudy', label: 'Field of Study' },
        { name: 'startDate', label: 'Start Date', type: 'date' },
        { name: 'endDate', label: 'End Date', type: 'date' },
        {
          name: 'document',
          label: 'Education Certificate',
          type: 'uploadButton',
          component: UploadButton,
          props: {
            acceptedFiles: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
            buttonText: 'Upload Education Certificate',
            onUploadSuccess: (response) => {
              if (response?.code === 1) {
                const documentData = {
                  docName: response.id.toString(),
                  docPath: response.doclink
                };
                if (isAdd) {
                  handleAddChange(`employeeEducationCertificateDocument`, documentData);
                } else {
                  handleEditChange('document', documentData);
                }
              }
            }
          }
        }
      ],


      licenses: [
        { name: 'titleOfLicense', label: 'Title of License' },
        { name: 'issuingOrganization', label: 'Issuing Organization' },
        { name: 'validityDate', label: 'Validity Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: nationality
        },
        {
          name: 'document',
          label: 'License Document',
          type: 'uploadButton',
          component: UploadButton,
          props: {
            acceptedFiles: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
            buttonText: 'Upload License Document',
            onUploadSuccess: (response) => {
              const documentData = {
                docName: response.data.fileName,
                docPath: response.data.imageUrl
              };
              if (isAdd) {
                handleAddChange(`employeeLicenseCertificateDocument`, documentData);
              } else {
                handleEditChange('document', documentData);
              }
            }
          }
        }
      ],
      certifications: [
        { name: 'titleOfCertification', label: 'Title of Certification' },
        { name: 'issuingOrganization', label: 'Issuing Organization' },
        { name: 'validityDate', label: 'Validity Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: nationality
        },
        {
          name: 'document',
          label: 'Certificate Document',
          type: 'uploadButton',
          component: UploadButton,
          props: {
            acceptedFiles: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
            buttonText: 'Upload Certificate Document',
            onUploadSuccess: (response) => {
              const documentData = {
                docName: response.data.fileName,
                docPath: response.data.imageUrl
              };
              if (isAdd) {
                handleAddChange(`employeeCertificateDocument`, documentData);
              } else {
                handleEditChange('document', documentData);
              }
            }
          }
        }
      ],
      'work-experiences': [
        { name: 'organizationName', label: 'Organization Name' },
        { name: 'designation', label: 'Designation' },
        { name: 'startDate', label: 'Start Date', type: 'date' },
        { name: 'endDate', label: 'End Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: nationality
        },
        { name: 'jobDescription', label: 'Job Description', multiline: true }
      ],
      associations: [
        { name: 'associationName', label: 'Association Name' },
        { name: 'memberType', label: 'Member Type' },
        { name: 'validityDate', label: 'Validity Date', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: nationality
        }
      ],
      'awards-recognition': [
        { name: 'title', label: 'Award Title' },
        { name: 'issuingOrganization', label: 'Issuing Organization' },
        { name: 'validityDate', label: 'Date Awarded', type: 'date' },
        {
          name: 'nationalityId',
          label: 'Nationality',
          type: 'select',
          options: nationality
        },
        {
          name: 'document',
          label: 'Award Document',
          type: 'uploadButton',
          component: UploadButton,
          props: {
            acceptedFiles: '.pdf,.doc,.docx,.jpg,.jpeg,.png',
            buttonText: 'Upload Award Document',
            onUploadSuccess: (response) => {
              const documentData = {
                docName: response.data.fileName,
                docPath: response.data.imageUrl
              };
              if (isAdd) {
                handleAddChange(`employeeAwardDocument`, documentData);
              } else {
                handleEditChange('employeeAwardDocument', documentData);
              }
            }
          }
        }
      ]
    };

    return baseFields[section] || [];
  };

  // Update handleEditSubmit
  const handleEditSubmit = async () => {
    try {
      let endpoint = '';
      switch (editingSection) {
        case 'education':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-education/${editingItem.id}/update-employee-education`;
          break;
        case 'licenses':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-license/${editingItem.id}/update-employee-license`;
          break;
        case 'certifications':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-certificate/${editingItem.id}/update-employee-certificate`;
          break;
        case 'work-experiences':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-work-experience/${editingItem.id}/update-employee-work-experience`;
          break;
        case 'associations':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-association/${editingItem.id}/update-employee-association`;
          break;
        case 'awards-recognition':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem('userId')}/employee-award-recognition/${editingItem.id}/update-employee-award`;
          break;
      }

      const payload = { ...editValues };

      // Map document field back to the correct field name
      if (payload.document) {
        if (editingSection === 'education') {
          payload.employeeEducationCertificateDocument = payload.document;
        } else if (editingSection === 'licenses') {
          payload.employeeLicenseCertificateDocument = payload.document;
        } else if (editingSection === 'certifications') {
          payload.employeeCertificateDocument = payload.document;
        }
        delete payload.document; // Remove the generic document field
      }

      const response = await put(endpoint, payload);
      if (response?.statusCode === 200) {
        toast.success('Updated successfully');
        await getProfileDetails();
        
        // Update completion status
        const sectionData = {
          education: profile?.educations?.length > 0,
          licenses: profile?.licenses?.length > 0,
          certifications: profile?.certificates?.length > 0,
          'work-experiences': profile?.workExperiences?.length > 0,
          associations: profile?.associations?.length > 0,
          'awards-recognition': profile?.awardAndRecognitions?.length > 0
        };
        updateCompletionStatus(editingSection, sectionData[editingSection]);
        
        handleEditClose();
      } else {
        toast.error('Update failed');
      }
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Update failed');
    }
  };

  const handleDeleteClick = (e, section, item) => {
    e.stopPropagation();
    setDeletingSection(section);
    setDeletingItem(item);
    setDeleteModalOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteModalOpen(false);
    setDeletingSection(null);
    setDeletingItem(null);
  };


  const handleDeleteConfirm = async () => {
    try {
      let endpoint = '';
      switch (deletingSection) {
        case 'education':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-education/employeeeducation/${deletingItem.id}`;
          break;
        case 'licenses':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-license/employee-license/${deletingItem.id}`;
          break;
        case 'certifications':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-certificate/employee-certificate/${deletingItem.id}`;
          break;
        case 'work-experiences':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/delete-employee-work-experience/employee-work-experience/${deletingItem.id}`;
          break;
        case 'associations':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/employee-association/${deletingItem.id}/delete-employee-award-association`;
          break;
        case 'awards-recognition':
          endpoint = `/employeeaccount/${profile?.id}/employee/${sessionStorage.getItem(
            'userId'
          )}/employee-award-recognition/${deletingItem.id}/delete-employee-award-recognition`;
          break;
      }

      const response = await del(endpoint);
      if (response?.message) {
        toast.success('Deleted successfully');
        await getProfileDetails();
        
        // Update completion status after deletion
        setTimeout(() => {
          const sectionData = {
            education: profile?.educations?.length > 1, // Will be 1 less after deletion
            licenses: profile?.licenses?.length > 1,
            certifications: profile?.certificates?.length > 1,
            'work-experiences': profile?.workExperiences?.length > 1,
            associations: profile?.associations?.length > 1,
            'awards-recognition': profile?.awardAndRecognitions?.length > 1
          };
          updateCompletionStatus(deletingSection, sectionData[deletingSection]);
        }, 100);
        
        handleDeleteClose();
      } else {
        toast.error('Delete failed');
      }
    } catch (error) {
      console.error('Error deleting:', error);
      toast.error('Delete failed');
    }
  };

  const handleAddClick = (section) => {
    setAddingSection(section);
    setAddValues({});
    setAddingModalOpen(true);
  };

  const handleAddClose = () => {
    setAddingModalOpen(false);
    setAddingSection(null);
    setAddValues({});
  };

  const handleAddChange = (name, value) => {
    setAddValues(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Add this constant at the top with other constants
  const DEFAULT_DOC_PATH = 'https://cdn-icons-png.flaticon.com/512/942/942748.png';
  const DEFAULT_DOC_NAME = 'defaultCert';

  // Add this new function to handle initial profile creation
  const createInitialProfile = async (section, entries) => {
    try {
      const payload = {
        licenseNumber: "TMP" + Date.now(), // Temporary license number
        dateOfLicense: new Date().toISOString(),
        licenseCertificateDocument: {
          docName: DEFAULT_DOC_NAME,
          docPath: DEFAULT_DOC_PATH
        },
        certificationIsValid: true,
        educations: [],
        licenses: [],
        certificates: [],
        workExperiences: [],
        associations: [],
        awardAndRecognitions: [],
        employeeId: parseInt(sessionStorage.getItem('userId'))
      };

      // Add the entries to the appropriate section
      switch (section) {
        case 'education':
          payload.educations = entries.map(entry => ({
            ...entry,
            employeeEducationCertificateDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
        case 'licenses':
          payload.licenses = entries.map(entry => ({
            ...entry,
            employeeLicenseCertificateDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
        case 'certifications':
          payload.certificates = entries.map(entry => ({
            ...entry,
            employeeLicenseCertificateDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
        case 'work-experiences':
          payload.workExperiences = entries;
          break;
        case 'associations':
          payload.associations = entries;
          break;
        case 'awards-recognition':
          payload.awardAndRecognitions = entries.map(entry => ({
            ...entry,
            employeeAwardDocument: {
              docName: DEFAULT_DOC_NAME,
              docPath: DEFAULT_DOC_PATH
            }
          }));
          break;
      }

      const response = await post('/employeeaccount/create-employee-account', payload);
      return response;
    } catch (error) {
      console.error('Error creating profile:', error);
      throw error;
    }
  };


  // Update handleAddSubmit to handle both initial creation and adding to existing profile
  const handleAddSubmit = async (entries) => {
    try {
      const processedEntries = entries.map(entry => {
        // Document info should already be included from upload handler
        return entry;
      });

      if (!profile) {
        // Create initial profile with the first section
        const response = await createInitialProfile(addingSection, entries);
        if (response?.statusCode === 200) {
          toast.success('Profile created successfully');
          await getProfileDetails(); // Fetch the newly created profile
          handleAddClose();
        } else {
          toast.error('Failed to create profile');
        }
      } else {
        // Use existing add endpoint logic for subsequent additions
        let endpoint = '';
        const userId = sessionStorage.getItem('userId');

        switch (addingSection) {
          case 'education':
            endpoint = `/employeeaccount/employeeeducations/${profile.id}/employee/${userId}`;
            break;
          case 'licenses':
            endpoint = `/employeeaccount/employee-licenses/${profile?.id}/employee/${userId}`;
            break;
          case 'certifications':
            endpoint = `/employeeaccount/add-add-employee-certificates/${profile?.id}/employee/${userId}`;
            break;
          case 'work-experiences':
            endpoint = `/employeeaccount/add-employee-work-experiences/${profile?.id}/employee/${userId}`;
            break;
          case 'associations':
            endpoint = `/employeeaccount/${profile?.id}/employee/${userId}/add-employee-associations`;
            break;
          case 'awards-recognition':
            endpoint = `/employeeaccount/${profile?.id}/employee/${userId}/add-employee-awards-recognitions`;
            break;
        }

        const response = await post(endpoint, processedEntries);
        if (response?.statusCode === 200) {
          toast.success('Added successfully');
          await getProfileDetails();
          
          // Update completion status
          updateCompletionStatus(addingSection, true);
          
          handleAddClose();
        } else {
          toast.error('Failed to add');
        }
      }
    } catch (error) {
      console.error('Error adding:', error);
      toast.error('Failed to add');
    }
  };

  const renderSectionHeader = (title, section) => (
    <div className="profile-accordion__section-header m-b-20">
      <Button
        startIcon={<AddIcon />}
        variant="contained"
        color="primary"
        size="small"
        onClick={() => handleAddClick(section)}
        sx={{ ml: 2 }}
      >
        Add New {section}
      </Button>
    </div>
  );

  const renderSectionContent = (id) => {
    // if (!profile) return null;

    switch (id) {
      case 'education':
        return (
          <>
            {renderSectionHeader('Education', 'education')}
            {profile?.educations?.map((entry) => (
              <div key={entry.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{entry.fieldOdStudy}</div>
                  <div className="profile-education__institution">{entry.institutionName}</div>
                  <div className="profile-education__years">
                    {formatDate(entry.startDate)} – {formatDate(entry.endDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() =>
                      handleViewDocument(entry.employeeEducationCertificateDocument, `Education Certificate - ${entry.institutionName}`)
                    }
                  >
                    View certificate
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'education', entry)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'education', entry)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );
      case 'personal-info':
        return (
          <>
            <div className="profile-education__card">
              <div className="profile-education__details">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6">Personal Info</Typography>
                  <div className="profile-education__actions">
                    <FaRegEdit
                      className="profile-education__edit-icon"
                      onClick={() => {
                        setEditingSection('personal-info');
                        setEditValues(personalInfo);
                        setEditModalOpen(true);
                      }}
                    />
                  </div>
                </Box>

                <Box className="two-column-form" display="grid" gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))" gap={2}>
                  <Typography><strong>Title:</strong> {personalInfo.title}</Typography>
                  <Typography><strong>First Name:</strong> {personalInfo.firstName}</Typography>
                  <Typography><strong>Middle Name:</strong> {personalInfo.middleName}</Typography>
                  <Typography><strong>Last Name:</strong> {personalInfo.lastName}</Typography>
                  <Typography><strong>Email:</strong> {personalInfo.email}</Typography>
                  <Typography><strong>Phone Number:</strong> {personalInfo.phoneNumber}</Typography>
                  <Typography><strong>ID Type:</strong> {['National ID', "Driver's License", 'Passport'][personalInfo.govtIssuedIDType - 1]}</Typography>
                  <Typography><strong>ID Number:</strong> {personalInfo.govtIssuedID}</Typography>
                  <Typography><strong>Account Type:</strong> {personalInfo.accountType === 'Clinic Member' ? 'Clinic Staff' : 'Private Practitioner'}</Typography>
                  <Typography><strong>Provider:</strong> {personalInfo.healthCareProvider?.name || ''}</Typography>
                  <Typography><strong>Specialization:</strong> {personalInfo.userRoles?.[0]?.roleSpecialist?.specialistName || ''}</Typography>
                  <Typography><strong>Office Address:</strong> {personalInfo.officeAddress}</Typography>
                  <Typography><strong>Gender:</strong> {personalInfo.gender?.charAt(0).toUpperCase() + personalInfo.gender?.slice(1)}</Typography>
                  <Typography><strong>Date of Birth:</strong> {personalInfo.dateOfBirth}</Typography>
                  <Typography><strong>Place of Birth:</strong> {personalInfo.placeOfBirth}</Typography>
                  <Typography><strong>State:</strong> {personalInfo.state?.name || ''}</Typography>
                  <Typography><strong>City:</strong> {personalInfo.city}</Typography>
                  <Typography><strong>Nationality:</strong> {personalInfo.nationality?.name || ''}</Typography>
                  <Typography>
                    <strong>Languages:</strong> {
                      personalInfo.spokenLanguages?.map(sl =>
                        spokenLanguagesOptions?.find(lang => lang.id === sl.spokenLanguageId)?.name
                      ).filter(Boolean).join(', ') || ''
                    }
                  </Typography>
                </Box>


              </div>
            </div>
          </>
        );


      case 'licenses':
        return (
          <>
            {renderSectionHeader('Licenses', 'licenses')}
            {profile?.licenses?.map((license) => (
              <div key={license.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{license.titleOfLicense}</div>
                  <div className="profile-education__institution">
                    {license.issuingOrganization}
                  </div>
                  <div className="profile-education__country">{license.nationality.name}</div>
                  <div className="profile-education__years">
                    Valid until: {formatDate(license.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() =>
                      handleViewDocument(license.employeeLicenseCertificateDocument, `License - ${license.titleOfLicense}`)
                    }
                  >
                    View License
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'licenses', license)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'licenses', license)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      case 'certifications':
        return (
          <>
            {renderSectionHeader('Certifications', 'certifications')}
            {profile?.certificates?.map((cert) => (
              <div key={cert.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{cert.titleOfCertification}</div>
                  <div className="profile-education__institution">{cert.issuingOrganization}</div>
                  <div className="profile-education__country">{cert.nationality.name}</div>
                  <div className="profile-education__years">
                    Valid until: {formatDate(cert.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() =>
                      handleViewDocument(cert.employeeCertificateDocument, `Certificate - ${cert.titleOfCertification}`)
                    }
                  >
                    View Certificate
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'certifications', cert)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'certifications', cert)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      case 'work-experiences':
        return (
          <>
            {renderSectionHeader('Work Experiences', 'work-experiences')}
            {profile?.workExperiences?.map((exp) => (
              <div key={exp.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{exp.designation}</div>
                  <div className="profile-education__institution">
                    {exp.organizationName}
                  </div>
                  <div className="profile-education__country">{exp.nationality.name}</div>
                  <div className="profile-education__years">
                    {formatDate(exp.startDate)} – {formatDate(exp.endDate)}
                  </div>
                  <div className="profile-education__description">{exp.jobDescription}</div>
                </div>
                <div className="profile-education__actions">
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'work-experiences', exp)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'work-experiences', exp)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>

              </div>
            ))}
          </>
        );

      case 'associations':
        return (
          <>
            {renderSectionHeader('Associations', 'associations')}
            {profile?.associations?.map((assoc) => (
              <div key={assoc.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{assoc.associationName}</div>
                  <div className="profile-education__institution">
                    Member Type: {assoc.memberType}
                  </div>
                  <div className="profile-education__country">{assoc.nationality.name}</div>
                  <div className="profile-education__years">
                    Valid until: {formatDate(assoc.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'associations', assoc)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'associations', assoc)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      case 'awards-recognition':
        return (
          <>
            {renderSectionHeader('Awards & Recognition', 'awards-recognition')}
            {profile?.awardAndRecognitions?.map((award) => (
              <div key={award.id} className="profile-education__card">
                <div className="profile-education__details">
                  <div className="profile-education__degree">{award.title}</div>
                  <div className="profile-education__institution">
                    {award.issuingOrganization}
                  </div>
                  <div className="profile-education__country">{award.nationality.name}</div>
                  <div className="profile-education__years">
                    Awarded: {formatDate(award.validityDate)}
                  </div>
                </div>
                <div className="profile-education__actions">
                  <button
                    className="profile-education__view-certificate"
                    onClick={() => handleViewDocument(award.employeeAwardDocument, `Award - ${award.title}`)}
                  >
                    View Award
                  </button>
                  <FaRegEdit
                    className="profile-education__edit-icon"
                    onClick={(e) => handleEditClick(e, 'awards-recognition', award)}
                  />
                  <DeleteIcon
                    className="profile-education__delete-icon"
                    onClick={(e) => handleDeleteClick(e, 'awards-recognition', award)}
                    sx={{
                      color: 'error.main',
                      cursor: 'pointer',
                      ml: 1,
                      '&:hover': { color: 'error.dark' }
                    }}
                  />
                </div>
              </div>
            ))}
          </>
        );

      default:
        return null;
    }
  };

  if (loading) {
    return (
      <Box sx={{ p: 4 }}>
        <Stack spacing={3}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Skeleton variant="circular" width={64} height={64} />
            <Box>
              <Skeleton variant="text" width={180} height={32} />
              <Skeleton variant="text" width={120} height={24} />
            </Box>
          </Box>
          <Skeleton variant="rectangular" height={40} width="60%" />
          <Skeleton variant="rectangular" height={40} width="40%" />
          <Skeleton variant="rectangular" height={60} width="100%" />
          <Skeleton variant="rectangular" height={60} width="100%" />
          <Skeleton variant="rectangular" height={60} width="100%" />
        </Stack>
      </Box>
    );
  }

  return (
    <>
      <div className="profile-page__container w-100 main-content">
        {/* <div className="profile-top-header">
          <div className="profile-top-header__profile-info">
            <img
              src={profilePic}
              alt="Profile"
              className="profile-top-header__profile-pic"
            />
            <div className="profile-top-header__text-info">
              <span className="profile-top-header__name">
                {profile?.employee?.firstName} {profile?.employee?.lastName}
              </span>
            </div>
          </div>
        </div> */}

        <div className="profile-page__body-wrapper w-100">
          <main className="profile-main-content-accordion w-100">
            <h2 className="profile-main-content-accordion__title">Career/Certifications</h2>
            <p className="profile-main-content-accordion__instruction">
              Please provide the following information to get started!
            </p>

            <div className="profile-accordion-container w-100">
              {sections.map((section) => (
                <div key={section.id} className="profile-accordion__item">
                  <div
                    className={`profile-accordion__header ${openAccordion === section.id
                      ? 'profile-accordion__header--open'
                      : ''
                      }`}
                    onClick={() => toggleAccordion(section.id)}
                  >
                    <div className="profile-accordion__header-left">
                      <section.icon className="profile-accordion__icon" />
                      <span className="profile-accordion__label">{section.label}</span>
                    </div>
                    {openAccordion === section.id ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                  {openAccordion === section.id && (
                    <div className="profile-accordion__content">
                      {renderSectionContent(section.id)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>

      <EditModal
        open={editModalOpen}
        onClose={handleEditClose}
        title={`Edit ${editingSection?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`}
        fields={editingSection === 'personal-info' ? personalInfoFields : getFieldsForSection(editingSection)}
        values={editValues}
        onChange={handleEditChange}
        onSubmit={editingSection === 'personal-info' ? () => handlePersonalInfoSubmit(editValues) : handleEditSubmit}
      />


      <AddModal
        open={addingModalOpen}
        onClose={handleAddClose}
        title={`Add ${addingSection?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}`}
        fields={getFieldsForSection(addingSection, true)}
        values={addValues}
        onChange={handleAddChange}
        onSubmit={handleAddSubmit}
        docUploading={docUploading}
      />

      <ConfirmationModal
        open={deleteModalOpen}
        onClose={handleDeleteClose}
        onConfirm={handleDeleteConfirm}
        title="Confirm Delete"
        message={`Are you sure you want to delete this ${deletingSection?.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} record?`}
      />

      <ImageViewerModal
        open={imageViewerOpen}
        onClose={() => setImageViewerOpen(false)}
        imageUrl={viewingImage.url}
        title={viewingImage.title}
      />
    </>
  );
}

export default ProfilePage;
